'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _NotificationBar = require('./NotificationBar');

var _NotificationBar2 = _interopRequireDefault(_NotificationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NotificationBar2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NotificationBar/index.js
// module id = 272
// module chunks = 11